import { Injectable } from "@angular/core"
import { AngularFirestoreCollection } from "@angular/fire/firestore"
import { Observable } from "rxjs"

import { Bug } from "@tr/models"
import { FirebaseCollectionBase } from "./firebase-resource-base"
import { FirebaseService } from "./firebase.service"

@Injectable({
  providedIn: "root",
})
export class BugsService extends FirebaseCollectionBase<Bug> {
  public getId = (item: Bug) => item._id

  constructor(fb: FirebaseService) {
    super(fb)
  }

  public getCollection(company: string, project: string): AngularFirestoreCollection {
    return this.firebaseService
      .collection("companies")
      .doc(company)
      .collection("projects")
      .doc(project)
      .collection<Bug>("Bugs")
  }

  public async getData(company: string, project: string): Promise<Bug[]> {
    const collectionSnapshot = await this.getCollection(company, project)
      .ref.get()

    this.data = collectionSnapshot.empty
      ? []
      : collectionSnapshot.docs.map<Bug>(bugSnapshot => {
        if (!bugSnapshot.exists) {
          return null
        }

        const bug = bugSnapshot.data() as Bug
        bug._id = bugSnapshot.id
        this.dataMap[bugSnapshot.id] = bug
        return bug
      })

    return this.data
  }

  public getDataItemChanges(id: string, company: string, project: string): Observable<Bug> {
    return this.getCollection(company, project).doc<Bug>(id).valueChanges()
  }

  public async getDataItem(id: string, company: string, project: string, refresh = false): Promise<Bug> {
    if (refresh || !this.dataMap[id]) {
      const itemSnapshot = await this.getCollection(company, project)
        .doc(id)
        .ref.get()

      if (!itemSnapshot.exists) {
        return null
      }

      const item = itemSnapshot.data() as Bug
      item._id = itemSnapshot.id
      this.dataMap[id] = item
    }

    return this.dataMap[id]
  }
}
